import React, { useState } from 'react';
import { Button, InputAdornment } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { FormProvider, useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import CommentaryValidator from '../../../validator/CommentaryValidator';
import FormInputWithRemainingChars from '@shared/components/form/FormInputWithRemainingChars';

const MIN_LENGTH = 25;
const MAX_LENGTH = 1000;

const COMMENTARY_FIELD = 'commentary';

const PLACEHOLDER = 'N/A';

/**
 * @typedef {object} CommentaryInputProps
 * @property {string} [commentary]
 * @property {(commentary: string) => void} [handleSaveCommentary]
 */

/**
 * @param {CommentaryInputProps} props
 */
const CommentaryInput = props => {
  const { commentary, handleSaveCommentary } = props;

  const [isEditing, setIsEditing] = useState(false);

  const form = useForm({
    resolver: joiResolver(CommentaryValidator.schema),
    defaultValues: { [COMMENTARY_FIELD]: commentary ?? '' }
  });

  const {
    formState: { isDirty, isValid },
    reset,
    handleSubmit
  } = form;

  const enableSaveBtn = isDirty && isValid;

  const onSubmit = data => {
    handleSaveCommentary(data.commentary);
    setIsEditing(false);
    reset(data);
  };

  const handlePencilClick = () => {
    setIsEditing(true);
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit)} className='input-area'>
        <FormInputWithRemainingChars
          name={COMMENTARY_FIELD}
          disabled={!isEditing}
          minLength={MIN_LENGTH}
          maxLength={MAX_LENGTH}
          placeholder={PLACEHOLDER}
          rows={6}
          endAdornment={
            !isEditing ? (
              <InputAdornment position='end' className='pencil-icon-adornment'>
                <EditOutlinedIcon
                  className='pencil-icon'
                  data-testid='EditOutlinedIcon'
                  onClick={handlePencilClick}
                />
              </InputAdornment>
            ) : null
          }
        />
        <Button type='submit' className='primary-button sm' disabled={!enableSaveBtn}>
          Save
        </Button>
      </form>
    </FormProvider>
  );
};

export default CommentaryInput;
